import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "less",
  extensions: [".less"],
  aliases: ["Less", "less"],
  mimetypes: ["text/x-less", "text/less"],
  loader: () => import('./less.js')
});
